import { useState, useEffect } from "react";
import { HeroHorarios } from "../../components/horarios/HeroHorarios";
import { TabsNivel } from "../../components/horarios/TabsNivel";
import { GridCursos } from "../../components/horarios/GridCursos";

import { useHorarios } from "../../hooks/UseHorario";
import { useHorariosCategoria } from "../../hooks/UseHorario";

export const Horarios = () => {

    const {
        horarios,
        loading,
        error,
        cargarHorarios,
    } = useHorarios();


    const {
        categorias,
        loadingCat,
        errorCat,
        cargarCategorias,
    } = useHorariosCategoria();


    const [nivel, setNivel] = useState(1);


    useEffect(() => {

        cargarCategorias();
        cargarHorarios();

    }, []);


    console.log("HORARIOS:", horarios);
    console.log("CATEGORIAS:", categorias);


    // =====================================================
    // BUSCAR LA CATEGORÍA SELECCIONADA
    // =====================================================

    const categoriaSeleccionada = categorias.find(
        (categoria) => categoria.id == nivel
    );


    // =====================================================
    // FILTRAR HORARIOS POR CATEGORÍA
    // =====================================================

    const cursos = horarios.filter(
        (horario) =>
            horario.categoria_id == nivel
    );


    return (
        <>
            <HeroHorarios />

            <TabsNivel
                nivel={nivel}
                setNivel={setNivel}
                categorias={categorias}
            />

            <GridCursos
                cursos={cursos}
                horarios={horarios}
                categoria={categoriaSeleccionada}
            />
        </>
    );
};